import React, { useState, useEffect } from 'react';
import DashboardHeader from '../../../components/DashboardHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import { auth, db } from '../../../auth/firebase';
import { doc, updateDoc } from 'firebase/firestore';
import cacheManager from '../../../auth/cache_manager';
import { 
  FaUserCircle,
  FaBookMedical,
  FaUserMd,
  FaCertificate,
  FaHospital
} from 'react-icons/fa';
import './roadmaps.css';

function Roadmaps() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // # Load theme preference from user data on initial render
  useEffect(() => {
    const loadThemePreference = async () => {
      if (auth.currentUser?.uid) {
        // # Try to get from cache first
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData && userData.themes && userData.themes.gen_theme !== undefined) {
          setIsDarkMode(userData.themes.gen_theme === 'dark');
        }
      }
    };
    
    loadThemePreference();
  }, []);

  // # Handle theme toggle
  const handleThemeToggle = async () => {
    try {
      const newTheme = !isDarkMode;
      setIsDarkMode(newTheme);
      
      // # Update theme in Firebase if user is logged in
      if (auth.currentUser?.uid) {
        // # Update the user document
        await updateDoc(doc(db, 'users', auth.currentUser.uid), {
          'themes.gen_theme': newTheme ? 'dark' : 'light'
        });
        
        // # Update cache manager
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData) {
          const updatedUserData = {
            ...userData,
            themes: {
              ...(userData.themes || {}),
              gen_theme: newTheme ? 'dark' : 'light'
            }
          };
          cacheManager.set(`user_${auth.currentUser.uid}`, updatedUserData);
        }
      }
    } catch (error) {
      console.error('Error updating theme preference:', error);
    }
  };

  // # Define roadmap sections with icons and descriptions
  const roadmapSections = [
    {
      title: 'ECFMG Account',
      icon: <FaUserCircle className="ext_rdmp_section-icon" />,
      description: 'Guide to creating and managing your ECFMG account'
    },
    {
      title: 'USMLE Step 1',
      icon: <FaBookMedical className="ext_rdmp_section-icon" />,
      description: 'Complete roadmap for USMLE Step 1 preparation'
    },
    {
      title: 'USMLE Step 2',
      icon: <FaUserMd className="ext_rdmp_section-icon" />,
      description: 'Comprehensive guide for USMLE Step 2 success'
    },
    {
      title: 'ECFMG Certification',
      icon: <FaCertificate className="ext_rdmp_section-icon" />,
      description: 'Step-by-step process for ECFMG certification'
    },
    {
      title: 'The Match',
      icon: <FaHospital className="ext_rdmp_section-icon" />,
      description: 'Guide to the US residency match process'
    }
  ];

  return (
    <div className={`ext_rdmp_page-container ${isDarkMode ? 'ext_rdmp_dark-mode' : ''}`}>
      <DashboardHeader isDarkMode={isDarkMode} onThemeToggle={handleThemeToggle} />
      
      <main className="ext_rdmp_main-content">
        <div className="ext_rdmp_header">
          <h1>Study Roadmaps</h1>
          <p>Your comprehensive guide to USMLE preparation and residency</p>
        </div>

        <div className="ext_rdmp_sections-grid">
          {roadmapSections.map((section, index) => (
            <div 
              key={index}
              className="ext_rdmp_section-card"
            >
              <div className="ext_rdmp_icon-container">
                {section.icon}
              </div>
              <h3>{section.title}</h3>
              <p>{section.description}</p>
              <div className="ext_rdmp_coming-soon">Coming Soon</div>
            </div>
          ))}
        </div>
      </main>

      <DashboardFooter isDarkMode={isDarkMode} />
    </div>
  );
}

export default Roadmaps; 